// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import instadate from 'instadate';
import Datepicker from '../common/datepicker/datepicker';
import { formActions, mergeActionsToProps } from 'redux-pure-form';
import { DAY, WEEK, MONTH, REPORT, EVENT_ADD, DISPATCH, RESOURCE } from './calendar.consts.js';
import {
  redirectWithParams,
  formatDate,
  changeView,
  getTimestamp,
  getParamsForEventAction,
  paramsToHash,
  newDate
} from './calendar.model.js';

type CalendarNavProps = {
  customFilterForm: {
    timezone: string,
    id: string
  },
  dispatchView: boolean,
  customHandleDateChange: () => void,
  organization: {
    organizationSettings: {
      enableResourceView: string,
      disablePilotView: string
    }
  }
};

type CalendarNavState = {
  selected: string | null
};

class CalendarNav extends React.Component<CalendarNavProps, CalendarNavState> {
  constructor(props) {
    super(props);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleCreateEvent = this.handleCreateEvent.bind(this);
  }

  state = {
    selected: null
  };

  handleDateChange(val, arrow) {
    const { customHandleDateChange, organization } = this.props;
    const { selected } = this.state;
    let value = new Date(val);
    let paramsDate, sessionData;

    let orgID = window.sessionStorage.getItem('orgID');

    if (organization.id === orgID) {
      sessionData = window.sessionStorage.getItem('selectedDate');
    }

    paramsDate = instadate.resetTimezoneOffset(
      new Date(selected || sessionData || this.props.URL.element)
    );

    if (arrow === 'left') value = instadate.addDays(paramsDate, -1);
    if (arrow === 'right') value = instadate.addDays(paramsDate, 1);
    if (arrow === 'today') value = new Date();

    const element = formatDate(value.getTime() / 1000, 0, 'Y-m-d', false, false);

    window.sessionStorage.setItem('orgID', organization.id);
    window.sessionStorage.setItem('selectedDate', element);

    if (customHandleDateChange) {
      this.setState(
        {
          selected: element
        },
        () => {
          customHandleDateChange(element);
        }
      );
      return;
    }

    const { URL, filterForm, userFilters } = this.props;

    return redirectWithParams(
      {
        ...URL,
        element
      },
      filterForm,
      userFilters[filterForm.id]
    );
  }

  handleCreateEvent() {
    const date = instadate.resetTimezoneOffset(new Date());
    const params = getParamsForEventAction(EVENT_ADD, {
      org: this.props.organization.unique,
      day: this.props.daysList[0],
      startTime: getTimestamp(date),
      finishTime: getTimestamp(date) + parseInt(this.props.user.eventDefaultLength, 10)
    });
    this.props.fieldAttrs.onChange('URL.eventBreadcrumbs', [params]);
    return this.props.paramsToHash(params);
  }

  getSelected() {
    const { selected } = this.state;
    const { URL, organization } = this.props;
    const date = new Date(URL.element);
    const orgID = window.sessionStorage.getItem('orgID');
    let sessionData;
    if (orgID === organization.id) {
      sessionData = window.sessionStorage.getItem('selectedDate');
    } else {
      window.sessionStorage.removeItem('orgID');
      window.sessionStorage.removeItem('selectedDate');
      window.sessionStorage.removeItem('filterLocation');
    }

    return (
      selected ||
      (sessionData && instadate.resetTimezoneOffset(new Date(sessionData))) ||
      newDate(getTimestamp(date))
    );
  }

  render() {
    const { URL, user, organizationsAccess, userFilters, dispatchView, organization } = this.props;
    let { filterForm } = this.props;

    if (!organization || !organization.organizationSettings) {
      return null;
    }

    const { enableResourceView, disablePilotView } = organization.organizationSettings;

    const storage = window.sessionStorage;

    if (URL.action === DISPATCH && storage.getItem('filterForm')) {
      filterForm = JSON.parse(storage.getItem('filterForm'));
    }

    if (!filterForm) return null;

    return (
      <div className="nav-wrap subtitle">
        <div className="datepicker-wrap">
          <button
            className="btn btn-default"
            style={{ marginRight: '5px' }}
            onClick={this.handleDateChange.bind(this, null, 'today')}
          >
            today
          </button>
          <button
            className="btn btn-default icon chevron-left"
            style={{ marginRight: '5px' }}
            onClick={this.handleDateChange.bind(this, null, 'left')}
          />
          <Datepicker
            className="form-control inner-datepicker"
            selected={this.getSelected()}
            dateFormat={user.settings.date}
            onChange={this.handleDateChange}
            required
          />
          <button
            className="btn btn-default icon chevron-right"
            style={{ marginLeft: '5px' }}
            onClick={this.handleDateChange.bind(this, null, 'right')}
          />
        </div>
        <div className={`flex ${dispatchView && 'navbar-in-dispatch'}`}>
          <div className="btn-group btn-group-xs">
            <a
              href={changeView(MONTH, URL, filterForm, userFilters[filterForm.id])}
              className={`btn btn-default ${URL.action === MONTH ? 'btn-info' : ''}`}
              children={'Month View'}
            />
            <a
              href={changeView(WEEK, URL, filterForm, userFilters[filterForm.id])}
              className={`btn btn-default ${URL.action === WEEK ? 'btn-info' : ''}`}
              children={'Week View'}
            />
            <a
              href={changeView(DAY, URL, filterForm, userFilters[filterForm.id])}
              className={`btn btn-default ${URL.action === DAY ? 'btn-info' : ''}`}
              children={'Day View'}
            />
            {enableResourceView === '1' && (
              <a
                href={changeView(RESOURCE, URL, filterForm, userFilters[filterForm.id])}
                className={`btn btn-default ${URL.action === RESOURCE ? 'btn-info' : ''}`}
                children={'Stacked View'}
              />
            )}
            <a
              onClick={() => {
                if (URL.action !== DISPATCH) {
                  storage.setItem('filterForm', JSON.stringify(filterForm));
                }
              }}
              href={changeView(DISPATCH, URL, filterForm, userFilters[filterForm.id])}
              className={`btn btn-default ${URL.action === DISPATCH ? 'btn-info' : ''}`}
              children={'Dispatch View'}
            />
            {disablePilotView !== '1' && (
              <a
                href={`${changeView(
                  REPORT,
                  URL,
                  filterForm,
                  userFilters[filterForm.id],
                  true,
                  user.id
                )}`}
                className={`btn btn-default ${URL.action === REPORT ? 'btn-info' : ''}`}
                children={'Pilot View'}
              />
            )}
          </div>
          {!dispatchView &&
          typeof organizationsAccess === 'object' &&
          Object.keys(organizationsAccess).length ? (
            <button
              onClick={this.handleCreateEvent}
              className="event-create-btn btn btn-success btn-xs"
            >
              <span className="icon plus-circled" /> Create event
            </button>
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  URL: state.URL,
  user: state.user,
  daysList: state.daysList,
  filterForm: state.filterForm || props.customFilterForm,
  userFilters: state.userFilters,
  organization: state.organization,
  organizationsAccess: state.organizationsAccess
});

export default connect(
  mapStateToProps,
  {
    ...formActions,
    paramsToHash
  },
  mergeActionsToProps
)(CalendarNav);
